var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"default-container"},[_c('img',{staticClass:"imgdefault",attrs:{"src":require("@/assets/images/noInfo.png"),"alt":""}}),_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.textContent || _vm.$t("common.noInfo")))])])}
var staticRenderFns = []

export { render, staticRenderFns }